import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-20 flex flex-col items-center gap-4" }
const _hoisted_2 = { class: "max-w-[90vw] mx-auto mt-7 md:mt-15" }
const _hoisted_3 = { class: "max-w-[300px] w-full mx-auto my-6 md:mt-10 mb-12 md:mb-20" }
const _hoisted_4 = { class: "text-center mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "max-w-[520px] mx-auto"
}
const _hoisted_6 = { class: "text-info-900" }

import { AppConfigType, PostType, ScheduleType } from '~src/admin/types';
import { inject, ref } from 'vue';
import Button from '../base/Button.vue';
import IconArrowLeft from '../icons/IconArrowLeft.vue';
import Card from '../layout/Card.vue';
import PostsTable from '../posts/PostsTable.vue';
import Axios from '~src/shared/axios';
import { useRouter } from 'vue-router';
import { useNotificationStore } from '~src/admin/stores/useNotificationStore';
import Message from '../base/Message.vue';
import { useGettext } from 'vue3-gettext';
import { useSchedulesStore } from '~src/admin/stores/useSchedulesStore';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'Summary',
  props: {
    schedule: {},
    isFirstSchedule: { type: Boolean }
  },
  emits: ["previousStep", "updateSchedule"],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Get schedule actions
const { addSchedule } = useSchedulesStore();

// Router
const router = useRouter();

// Show notification
const { addNotification } = useNotificationStore();

// Props


// Emits
const emit = __emit;

// Loading
const loading = ref(false);

// Get the date of the given weekday
const getDateOfPublication = (weekday: string, time: string) => {
    const today = new Date();

    // Get the next instance of the weekday
    const currentDay = today.getDay();
    let daysUntilNext = (Number(weekday) + 7 - currentDay) % 7;

    // If the weekday is the same day check time difference
    if (daysUntilNext === 0) {
        // Calculate time difference
        const currentHour = today.getHours();
        const currentMinute = today.getMinutes();
        const scheduleHour = parseInt(time.split(':')[0]);
        const scheduleMinute = parseInt(time.split(':')[1]);

        // Calculate difference in minutes
        const currentTotalMinutes = currentHour * 60 + currentMinute;
        const scheduleTotalMinutes = scheduleHour * 60 + scheduleMinute;
        const diffMinutes = scheduleTotalMinutes - currentTotalMinutes;

        // If time difference is less than 3 hours, add 7 days
        if (diffMinutes < 180) {
            daysUntilNext = 7;
        }
    }

    today.setDate(today.getDate() + daysUntilNext);

    // Format the date to YYYY-MM-DD HH:MM
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    const hours = time.split(':')[0];
    const minutes = time.split(':')[1];

    return `${year}-${month}-${day} ${hours}:${minutes}`;
};

// Posts to be displayed
const posts = ref<PostType[]>([]);

// Populate the posts
if (__props.schedule.advSchedule) {
    // Advanced schedule
    let index = 0;

    Object.keys(__props.schedule.advSchedule).forEach((key, dayIndex) => {
        __props.schedule.advSchedule[key].forEach((value, timeIndex) => {
            posts.value.push({
                id: index.toString(),
                title: `${$gettext('Article')} #${index + 1}`,
                publish_date: getDateOfPublication(key, value),
                status: 'schedule_generate',
                post_link: '',
                keywords: __props.schedule.articles_keywords?.[dayIndex]?.[timeIndex] ?? [],
                dayIndex: dayIndex,
                timeIndex: timeIndex,
            });
            index++;
        });
    });
} else {
    // Basic schedule
    __props.schedule.days.forEach((day, dayIndex) => {
        posts.value.push({
            id: dayIndex.toString(),
            title: `${$gettext('Article')} #${dayIndex + 1}`,
            publish_date: getDateOfPublication(day, __props.schedule.time),
            status: 'schedule_generate',
            post_link: '',
            keywords: __props.schedule.articles_keywords?.[dayIndex]?.[0] ?? [],
            dayIndex: dayIndex,
        });
    });
}

// Update keywords in schedule
const updateKeywordsInSchedule = (keywords: string[], dayIndex: number, timeIndex: number | null) => {
    // Create new keywords
    const newKeywords = __props.schedule.articles_keywords;

    if (timeIndex === null) {
        // Basic schedule
        newKeywords[dayIndex] = [keywords];
    } else {
        // Advanced schedule
        newKeywords[dayIndex][timeIndex] = keywords;
    }

    // Update the schedule
    const newSchedule = {
        ...__props.schedule,
        articles_keywords: newKeywords,
    };

    emit('updateSchedule', newSchedule);
};

// Finish setup
const finishSetup = async () => {
    try {
        // Set loading
        loading.value = true;

        if (!__props.isFirstSchedule) {
            // Add new schedule in Boostsite

            // Set url and body
            const bodyBoostsite = {
                action: 'add',
                schedule: __props.schedule,
            };

            // Save the schedule in Boostsite API
            const responseBoostsite = await Axios.post(`${config.rest.endpoints.boostsite}/schedules`, bodyBoostsite);

            // Check if the response is successful
            if (responseBoostsite.status !== 200 || !responseBoostsite.data.success) {
                throw new Error(`REST API error: ${responseBoostsite.status} - ${responseBoostsite.statusText}`);
            }
        } else {
            // Create the plugin settings

            // Prepare new settings
            const newSettings = {
                ...config.settings,
                schedules: [__props.schedule],
            };

            // Body
            const bodyWP = {
                settings: newSettings,
                update_boostsite: true,
            };

            // Call the WordPress Rest API to save schedule
            const responseWP = await Axios.post(config.rest.endpoints.settings, bodyWP);

            // Check if the response is successful
            if (responseWP.status !== 200 || !responseWP.data.success) {
                throw new Error(`REST API error: ${responseWP.status} - ${responseWP.statusText}`);
            }
        }

        // Add schedule to store
        addSchedule(__props.schedule);

        addNotification({
            message: $gettext('Succefully added new schedule!'),
            type: 'success',
        });

        addNotification(
            {
                message: $gettext(
                    'Your articles are being generated in the background! Please wait a few minutes and refresh the page.'
                ),
                type: 'success',
            },
            60
        );

        // Refresh the page
        setTimeout(() => {
            router.go(0);
        }, 1000);
    } catch (error) {
        console.error('Error saving schedule:', error);

        addNotification({
            message: $gettext('There was an error with saving your schedule!'),
            type: 'danger',
        });
    } finally {
        // Set loading
        loading.value = false;
    }
};

// Account type
const isAccountFree = inject<boolean>('isAccountFree');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(isAccountFree))
        ? (_openBlock(), _createBlock(Message, {
            key: 0,
            message: 
                    _unref($gettext)(
                        'Keywords are assigned to a specific article and won\'t be reused for generating future articles in this schedule.'
                    )
                ,
            type: "info",
            size: "large",
            "show-icon": true
          }, null, 8, ["message"]))
        : _createCommentVNode("", true),
      _createVNode(Message, {
        message: 
                    _unref($gettext)(
                        'Your articles will be generated in the background. Please check back and refresh the page to see them.'
                    )
                ,
        type: "info",
        size: "large",
        "show-icon": true
      }, null, 8, ["message"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PostsTable, {
        loading: false,
        posts: posts.value,
        type: "compact",
        onUpdateKeywords: _cache[0] || (_cache[0] = (keywords, dayIndex, timeIndex) => updateKeywordsInSchedule(keywords, dayIndex, timeIndex))
      }, null, 8, ["posts"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Button, {
        class: "w-full",
        text: _unref(isAccountFree) ? _unref($gettext)('Generate article') : _unref($gettext)('Generate articles'),
        size: "large",
        onClick: _withModifiers(finishSetup, ["prevent"]),
        loading: loading.value
      }, null, 8, ["text", "loading"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Button, {
          text: _unref($gettext)('back to Settings'),
          size: "small",
          "has-background": false,
          type: "secondary",
          "icon-position": "left",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('previousStep')), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(IconArrowLeft)
          ]),
          _: 1
        }, 8, ["text"])
      ])
    ]),
    (_unref(isAccountFree))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(Card, {
            "image-url": `${_unref(config).plugin_url}/public/images/first-schedule.png`,
            "image-alt": _unref($gettext)('Upgrade to premium plan')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(_unref($gettext)('On trial you can generate and publish only one article.')) + " ", 1),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "underline underline-offset-[3px]",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(router).push('/upgrade')), ["prevent"]))
                }, _toDisplayString(_unref($gettext)('Upgrade')), 1),
                _createTextVNode(" " + _toDisplayString(_unref($gettext)('to paid plan to publish more of them.')), 1)
              ])
            ]),
            _: 1
          }, 8, ["image-url", "image-alt"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})